// extracted by mini-css-extract-plugin
export var black = "_33-6";
export var brand = "_33-1";
export var ddefault = "_33-0";
export var error = "_33-3";
export var gray = "_33-2";
export var highContrast = "_33-8";
export var outline = "_33-7";
export var success = "_33-5";
export var warning = "_33-4";